const userAuthEndPoint = {
    registerUser: {
        url: `/registerUser`,
        method: "POST",
    }
}

export default userAuthEndPoint